"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifyResponseHeaderSecurity = exports.X_SECURITY_TOKEN = exports.CallMode = exports.BiometricValidationModeType = exports.AssistedLoginVerifyModeType = exports.AssistedLoginVerifySubCodeType = exports.AssistedLoginVerifyCodeType = exports.PushStatusType = void 0;
var PushStatusType;
(function (PushStatusType) {
    PushStatusType["SUCCESS"] = "SUCCESS";
    PushStatusType["INCOMPLETE"] = "INCOMPLETE";
})(PushStatusType || (exports.PushStatusType = PushStatusType = {}));
var AssistedLoginVerifyCodeType;
(function (AssistedLoginVerifyCodeType) {
    AssistedLoginVerifyCodeType["SUCCESS"] = "SUCCESS";
    AssistedLoginVerifyCodeType["DECLINED"] = "DECLINED";
    AssistedLoginVerifyCodeType["INCOMPLETE"] = "INCOMPLETE";
    AssistedLoginVerifyCodeType["ERROR"] = "ERROR";
})(AssistedLoginVerifyCodeType || (exports.AssistedLoginVerifyCodeType = AssistedLoginVerifyCodeType = {}));
var AssistedLoginVerifySubCodeType;
(function (AssistedLoginVerifySubCodeType) {
    AssistedLoginVerifySubCodeType["ERROR_INIT"] = "ERROR_INIT";
    AssistedLoginVerifySubCodeType["ERROR_STATUS"] = "ERROR_STATUS";
    AssistedLoginVerifySubCodeType["ERROR_VERIFY"] = "ERROR_VERIFY";
})(AssistedLoginVerifySubCodeType || (exports.AssistedLoginVerifySubCodeType = AssistedLoginVerifySubCodeType = {}));
var AssistedLoginVerifyModeType;
(function (AssistedLoginVerifyModeType) {
    AssistedLoginVerifyModeType["MANUAL"] = "MANUAL";
    AssistedLoginVerifyModeType["POLLING"] = "POLLING";
})(AssistedLoginVerifyModeType || (exports.AssistedLoginVerifyModeType = AssistedLoginVerifyModeType = {}));
var BiometricValidationModeType;
(function (BiometricValidationModeType) {
    BiometricValidationModeType["IN_APP"] = "IN_APP";
})(BiometricValidationModeType || (exports.BiometricValidationModeType = BiometricValidationModeType = {}));
var CallMode;
(function (CallMode) {
    CallMode["MANUAL"] = "manual";
    CallMode["POLLING"] = "polling";
})(CallMode || (exports.CallMode = CallMode = {}));
exports.X_SECURITY_TOKEN = 'x-security';
var VerifyResponseHeaderSecurity;
(function (VerifyResponseHeaderSecurity) {
    VerifyResponseHeaderSecurity["PASSWORD_EXPIRED"] = "Login-Password-Expired";
    VerifyResponseHeaderSecurity["ONBOARDING"] = "onboarding";
})(VerifyResponseHeaderSecurity || (exports.VerifyResponseHeaderSecurity = VerifyResponseHeaderSecurity = {}));
//# sourceMappingURL=types.js.map